import { ModelSagres } from "../../model-sagres"

import { ArquivoAditivo } from "../arquivo-aditivo"
import { Convenio } from "../convenio"
import { NaturezaAjuste } from "../natureza-ajuste"

import { UtilsTS } from "@/utilsts"

export class AditivoConvenio extends ModelSagres {
    IdAditivoConvenio: number
    IdConvenio: number
    IdNaturezaAjuste: number
    IdUnidGestora: number
    NrAditivoConvenio: number
    NrAnoAditivoConvenio: number
    DeJustificativaAditivo: string
    DtInicioVigenciaAditivo: Date | null
    DtFimVigenciaAditivo: Date | null
    VlAditivoConvenio: number | null
    DtCelebracaoAditivo: Date
    DtAnulacaoAditivo: Date | null
    DeMotivoAnulacaoAditivo: string | null
    DtPublicacaoAditivo: Date
    NmUsuarioUltimaAlteracao: string
    DtUltimaAlteracao: Date
    IdConvenioNavigation: Convenio
    IdNaturezaAjusteNavigation: NaturezaAjuste
    ArquivoAditivoConvenio: ArquivoAditivo[]

    DescricaoConvenio: string

    tratarDadosDaAPI(): void {
        if (this.DtInicioVigenciaAditivo) {
            this.DtInicioVigenciaAditivo = new Date(this.DtInicioVigenciaAditivo)
        }
        if (this.DtFimVigenciaAditivo) {
            this.DtFimVigenciaAditivo = new Date(this.DtFimVigenciaAditivo)
        }
        if (this.DtCelebracaoAditivo) {
            this.DtCelebracaoAditivo = new Date(this.DtCelebracaoAditivo)
        }

        if (this.DtAnulacaoAditivo) {
            this.DtAnulacaoAditivo = new Date(this.DtAnulacaoAditivo)
        }
        if (this.DtPublicacaoAditivo) {
            this.DtPublicacaoAditivo = new Date(this.DtPublicacaoAditivo)
        }
        if (this.DtUltimaAlteracao) {
            this.DtUltimaAlteracao = new Date(this.DtUltimaAlteracao)
        }

        if(this.IdConvenioNavigation)
            this.DescricaoConvenio = `${this.IdConvenioNavigation.NrConvenio}/${this.IdConvenioNavigation.NrAnoConvenio} - ${this.IdConvenioNavigation.DeObjetoConvenio}`
    }
}